import { Aaro } from 'aaro';
import { config } from 'Constants';

export const getStockMovements = (data) => {
	const user = JSON.parse(localStorage.getItem('user'));
	const aaro = new Aaro({
		baseUrl: config.url.AARO_BASE,
		accessToken: user.aaroToken,
	});
	return aaro.get('StokHareketleri', data);
};

export const getDekontKalem = (data) => {
	const user = JSON.parse(localStorage.getItem('user'));
	const aaro = new Aaro({
		baseUrl: config.url.AARO_BASE,
		accessToken: user.aaroToken,
	});
	return aaro.get('Dekont/Kalemler', data);
};

export const getDekontBaslik = (data) => {
	const user = JSON.parse(localStorage.getItem('user'));
	const aaro = new Aaro({
		baseUrl: config.url.AARO_BASE,
		accessToken: user.aaroToken,
	});
	return aaro.get('Dekont/Basliklar', data);
};
